<template>
  <div class="lime-body">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
        <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-separator-1">
              <li class="breadcrumb-item"><router-link to="/brands"><a href="#">Brands</a></router-link></li>
              <li class="breadcrumb-item active" aria-current="page">Brand Name</li>
            </ol>
          </nav>
          <div class="page-title">
            <h3>Brand detail</h3>
            <div class="search-create" v-if="currentPage === 'dashboard'">
              <router-link to="/admindashboard" class="btn btn-primary">
                <i class="material-icons">arrow_back</i>
                Back to Dashboard
              </router-link>
            </div>
            <div class="search-create" v-if="currentPage === 'brandlist'">
              <router-link to="/brands" class="btn btn-primary">
                <i class="material-icons">arrow_back</i>
                Back to Brand List
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row ">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body ">
              <div class="row" >
                <div class="col-md-12">
                  <div class="brand-detail">
                    <div class="brand-img">
                      <img class="img-fluid" v-bind:src="brandDetails.brand_logo" />
                    </div>
                    <ul>
                      <li><label>Brand Name</label><span>{{brandDetails.brand_name}}</span></li>
                      <li><label>Site URL</label><a :href=brandDetails.site_url target="_blank">{{brandDetails.site_url}}</a></li>
                      <li><label>Email</label><a href="mailto:info@adidas.com" target="_blank">{{brandDetails.email}}</a></li>
                      <li><label>Contact</label><span>{{brandDetails.contact_no}}</span></li>
                      <li><label>Address</label><span>{{brandDetails.address}}</span></li>
                      <li><label>Contact Name</label><span>{{brandDetails.contact_name_prefix + '.' + ' ' + brandDetails.contact_first_name + ' ' + brandDetails.contact_last_name}}</span></li>
                      <li><label>Contact Email</label><span>{{brandDetails.contact_email}}</span></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    name: 'brandDetail',
    components: {
      Loading
    },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        brandDetails: '',
        profileimage: localStorage.getItem('profile_img'),
        currentPage: ''
      }
    },
    methods: {
    },
    mounted () {
      var jwttoken = localStorage.getItem('jwt')
      var currentUrl = window.location.href
      var splitUrl = currentUrl.split('/')
      var brandId = splitUrl[4]
      var page = splitUrl[5]
      this.currentPage = page
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getBrandById' + '?' + 'uid' + '=' + brandId, {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          console.log(response)
          this.brandDetails = response.data.results[0]
          console.log(this.brandDetails)
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/brandDetail.vue